import React, {forwardRef, useImperativeHandle, useRef, useState} from 'react';
import {Button, Collapse, Descriptions, Empty, Modal, Tag, Tooltip, Typography} from 'antd';
import {useParams} from 'react-router-dom';
import {useAsyncRetry} from 'react-use';
import _ from 'lodash';
import classNames from 'classnames';

import {
    DeleteOutlined,
    EditOutlined,
    CommentOutlined,
    EyeOutlined,
    FileProtectOutlined,
    FileDoneOutlined,
} from '@/icons';
import {format} from '@/util/dateUtils';
import {deleteApiLink, getApiLinks, updateAppLinkAllows} from '@/api/clientApps';
import LocalApiSelectorModal from './LocalApiSelectorModal';
import LocalApiAkskFormModal from './extra/LocalApiAkskFormModal';
import DepartUserTagSelector from '@/page/admin/selector/DepartUserTagSelector';
import {AppTagTag, DepartTag, TagTag, UserTag} from '@/component';
import {allowList2Obj, allowObj2List} from './appAllowUtils';
import {useClientAppStore} from './context';
import LocalApiWxmpViewer from '@/page/admin/ClientAppsPage/ClientAppPage/extra/LocalApiWxmpViewer';
import LocalApiMiniView from './extra/LocalApiMiniView';

import styles from './styles.module.less';
import allowStyles from '@/page/admin/AppsPage/AppInfo.module.less';

const LocalApiList = forwardRef((props, ref) => {
    const LocalApiSelectorModalRef = useRef();
    const LocalApiAkskFormModalRef = useRef();
    const DepartUserTagSelectorRef = useRef();
    const LocalApiWxmpViewRef = useRef();
    const LocalApiMiniViewRef = useRef();

    const {clientAppId} = useParams();
    const selLinkRef = useRef(null);

    const [{clientApp}, dispatch] = useClientAppStore();
    const hasAppId = clientApp?.appId;

    const [activeKeys, setActiveKeys] = useState([]);

    const {value: apiLinks, loading, retry} = useAsyncRetry(() => {
        return getApiLinks(clientAppId, props.activeKey).then(({data}) => {
            console.log('11111', data);
            let {activeKey} = props;
            // 存在需绑定应用的接口，则在 context 中记录此配置
            if (!_.isEmpty(data)) {
                if (data.find(link => link?.apiDefine?.bindApp)) {
                    dispatch(['setBindAppApi', true]);
                }
            }
            let temp = data.filter(api =>
                activeKey == 'localApis'
                    ? api.apiDefine.interfaceType == 'localApis'
                    : api.apiDefine.interfaceType == 'wecomApis'
            );
            return temp || [];
        });
    }, [clientAppId, props.activeKey]);

    console.log('loacal api list:::value, loading', apiLinks, loading);

    /**
     * 打开 api 定义 modal，用于选择 api
     *
     * @public
     */
    function onApiSelectClick() {
        // console.log('clientAppId, clientApp', clientAppId, clientApp);
        // 读取当前已选择 api id 列表
        console.log('aaaaaaa', apiLinks);
        const selApiIds = apiLinks.map(link => link.apiId);

        LocalApiSelectorModalRef.current.showModal(selApiIds, props.activeKey);
    }

    /**
     * 展开所有列表
     *
     * @public
     */
    function expandAll() {
        console.log('expandAll');
        const linkIds = apiLinks.map(link => link.id);
        setActiveKeys(linkIds);
    }

    /**
     * 合拢所有列表
     *
     * @public
     */
    function collapseAll() {
        console.log('collapseAll');
        setActiveKeys([]);
    }

    useImperativeHandle(ref, () => ({
        onApiSelectClick,
        expandAll,
        collapseAll,
    }));

    function onChange(keys) {
        // console.log(keys);
        setActiveKeys(keys);
    }

    function needDefineAksk(link) {
        return link.apiDefine.needAksk && (!link.awsAk || !link.awsSk);
    }

    function onAkskClick(link) {
        return e => {
            e.stopPropagation();
            LocalApiAkskFormModalRef.current.showModal(link);
        };
    }

    function onWxmpClick(link) {
        return e => {
            // e.stopPropagation();
            console.log(link);
            // LocalApiWxmpViewRef.current.showEditModal();
        };
    }

    function onWecomMiniClick(link) {
        return e => {
            // e.stopPropagation();
            // console.log(link);
            // LocalApiMiniViewRef.current.showEditModal();
        };
    }

    function getLinkAllowObj(link) {
        const {apiAllows} = link;
        // apiAllows 为空表示无限制
        return _.isEmpty(apiAllows) ? null : allowList2Obj(apiAllows);
    }

    function onAllowClick(link) {
        return e => {
            e.stopPropagation();
            console.log(link);

            selLinkRef.current = link;
            DepartUserTagSelectorRef.current.showModal({
                modalTitle: '可见范围选择',
                initialValues: getLinkAllowObj(link),
            });
        };
    }

    function onAllowSelect(values) {
        console.log('onAllowSelect', values);
        const allows = allowObj2List(values);
        return updateAppLinkAllows(clientAppId, selLinkRef.current.id, allows).then(() => {
            retry();
            return true;
        });
    }

    function onDeleteClick(link) {
        return e => {
            e.stopPropagation();

            Modal.confirm({
                title: '警告',
                content: `确定删除「${link.apiDefine.apiName}」？`,
                okButtonProps: {
                    danger: true,
                },
                onOk: () => {
                    deleteApiLink(clientAppId, link.id).then(() => {
                        retry();
                    });
                },
            });
        };
    }

    function getPanelHeader(link) {
        const {apiDefine} = link;

        return (
            <div style={{float: 'left'}}>
                <Typography.Text>
                    <span style={{marginRight: 8, fontWeight: 'bold'}}>{apiDefine.apiName}</span>
                    {apiDefine.bindApp && <Tag color={hasAppId ? 'blue' : 'red'}>需关联应用</Tag>}
                </Typography.Text>
                <Typography.Paragraph type="secondary" style={{marginBottom: 0, display: 'flex'}}>
                    <div style={{width: 48}}>{apiDefine.apiMethod}</div>
                    <div>{apiDefine.apiUrl}</div>
                </Typography.Paragraph>
            </div>
        );
    }

    function renderAllow(label, allows, AllowTag) {
        if (_.isEmpty(allows)) {
            return null;
        }

        return (
            <Descriptions.Item label={label} labelStyle={{alignItems: 'center', width: 80}}>
                <div className={allowStyles.tags}>
                    {allows.map(({id, name}) => (
                        <AllowTag key={id} className={allowStyles.tag}>
                            {name}
                        </AllowTag>
                    ))}
                </div>
            </Descriptions.Item>
        );
    }

    function renderAllows(link) {
        // apiAllows 为空表示无限制
        const allowObj = getLinkAllowObj(link);

        if (allowObj) {
            const {departs, users, tags, adtags} = allowObj || {};
            return (
                <>
                    {renderAllow('可见部门', departs, DepartTag)}
                    {renderAllow('可见员工', users, UserTag)}
                    {renderAllow('可见标签', tags, TagTag)}
                    {renderAllow('AD 标签', adtags, AppTagTag)}
                </>
            );
        }

        return (
            <Descriptions.Item>
                <Tag>此接口未定义配置，将采用全局可见范围</Tag>
            </Descriptions.Item>
        );
    }

    function needWecomMini(link) {
        return link?.apiDefine?.extraType?.includes('wecommini') ?? false;
    }

    function renderLink(link) {
        const {apiDefine} = link;
        const {needAksk, customAllow, needWxmp, extraType} = apiDefine;
        const labelStyle = {width: 100, fontWeight: 'bold'};

        return (
            <>
                {needAksk && (
                    <Descriptions
                        column={2}
                        title={
                            <span>
                                AKSK 配置
                                <Tooltip title="定义 AKSK">
                                    <Button
                                        icon={<EditOutlined />}
                                        type="link"
                                        onClick={onAkskClick(link)}
                                    />
                                </Tooltip>
                            </span>
                        }
                        className={classNames(styles.meta, styles.apiInfo)}
                        style={{marginBottom: 24}}
                    >
                        <Descriptions.Item label="AK" labelStyle={labelStyle}>
                            {link.awsAk || '未定义'}
                        </Descriptions.Item>
                        <Descriptions.Item label="SK" labelStyle={labelStyle}>
                            {link.awsSk || '未定义'}
                        </Descriptions.Item>
                        <Descriptions.Item label="申请日期" labelStyle={labelStyle}>
                            {format(link.applyDate) || '未定义'}
                        </Descriptions.Item>
                        <Descriptions.Item label="申请员工" labelStyle={labelStyle}>
                            {link.person || '未定义'}
                        </Descriptions.Item>
                        <Descriptions.Item label="申请原因" labelStyle={labelStyle}>
                            {link.reason || '未定义'}
                        </Descriptions.Item>
                    </Descriptions>
                )}

                {needWxmp && (
                    <LocalApiWxmpViewer
                        ref={LocalApiWxmpViewRef}
                        link={link}
                        clientAppId={clientAppId}
                        reload={retry}
                    />
                )}

                {needWecomMini(link) && (
                    <LocalApiMiniView
                        ref={LocalApiMiniViewRef}
                        link={link}
                        clientAppId={clientAppId}
                        reload={retry}
                    />
                )}

                {customAllow && (
                    <Descriptions
                        column={1}
                        title={
                            <span>
                                接口可见范围
                                <Tooltip title="定义可见范围">
                                    <Button
                                        icon={<EditOutlined />}
                                        type="link"
                                        onClick={onAllowClick(link)}
                                    />
                                </Tooltip>
                            </span>
                        }
                        className={classNames(styles.meta, styles.apiInfo)}
                    >
                        {renderAllows(link)}
                    </Descriptions>
                )}
            </>
        );
    }

    function renderCollapsePanelExtra(link) {
        const {needAksk, customAllow, needWxmp} = link.apiDefine;
        const defineAksk = needDefineAksk(link);

        return (
            <Button.Group size="small">
                {needAksk && (
                    <Tooltip title={defineAksk && 'AKSK 如未定义，则此接口不可用'}>
                        <Button
                            icon={<FileProtectOutlined />}
                            type={defineAksk ? 'primary' : 'default'}
                            danger={defineAksk}
                            onClick={onAkskClick(link)}
                        >
                            定义 AKSK
                        </Button>
                    </Tooltip>
                )}
                {needWxmp && (
                    <Button icon={<CommentOutlined />} onClick={onWxmpClick(link)}>
                        公众号配置
                    </Button>
                )}
                {needWecomMini(link) && (
                    <Button icon={<FileDoneOutlined />} onClick={onWecomMiniClick(link)}>
                        小程序配置
                    </Button>
                )}

                {customAllow && (
                    <Button icon={<EyeOutlined />} onClick={onAllowClick(link)}>
                        定义可见范围
                    </Button>
                )}
                <Button title="删除" icon={<DeleteOutlined />} onClick={onDeleteClick(link)} />
            </Button.Group>
        );
    }

    return (
        <>
            {_.isEmpty(apiLinks) && <Empty style={{marginTop: 100}} />}

            <Collapse bordered={false} ghost={true} activeKey={activeKeys} onChange={onChange}>
                {apiLinks
                    ?.filter(link => !_.isEmpty(link?.apiDefine))
                    ?.map(link => {
                        return (
                            <Collapse.Panel
                                key={link.id}
                                header={getPanelHeader(link)}
                                extra={renderCollapsePanelExtra(link)}
                                className={styles.collapsePanel}
                            >
                                <div style={{marginLeft: 24}}>{renderLink(link)}</div>
                            </Collapse.Panel>
                        );
                    })}
            </Collapse>

            <LocalApiSelectorModal
                ref={LocalApiSelectorModalRef}
                clientAppId={clientAppId}
                reload={retry}
            />
            <LocalApiAkskFormModal
                ref={LocalApiAkskFormModalRef}
                clientAppId={clientAppId}
                reload={retry}
            />
            <DepartUserTagSelector
                ref={DepartUserTagSelectorRef}
                showAdTagTab
                onSelect={onAllowSelect}
            />
        </>
    );
});

LocalApiList.displayName = 'LocalApiList';

LocalApiList.propTypes = {};

export default LocalApiList;
